export const shouldRenderContextBannerSmartCard = ({
	useCurrentPageContext = true,
	isSpaceScopedConversation = false,
	hasActiveEditorContext,
	isBrowserContextBlocklisted = false,
	isBrowserContextLoading = false,
}: {
	useCurrentPageContext?: boolean;
	isSpaceScopedConversation?: boolean;
	hasActiveEditorContext: boolean;
	isBrowserContextBlocklisted?: boolean;
	isBrowserContextLoading?: boolean;
}): boolean => {
	return (
		useCurrentPageContext &&
		!isSpaceScopedConversation &&
		hasActiveEditorContext &&
		!isBrowserContextBlocklisted &&
		!isBrowserContextLoading
	);
};
